import type { ReactNode } from 'react';

type Props = { title: string; description?: string; actions?: ReactNode };

// the top of every admin page: what it is, what it is for, and its main actions
export function PageHeader({ title, description, actions }: Props) {
  return (
    <div className="admin-page-header">
      <div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="admin-page-actions">{actions}</div>}
    </div>
  );
}
